<template>
  <div>
    <div id="actions">
      <a-space :size="15">
        <a-button type="default" @click="() => visibleImportDataModal = true" icon="import"> Import</a-button>
        <a-button type="default" @click="() => visibleExportDataModal = true" icon="export"> Export</a-button>
        <a-button type="danger" @click="handleSoftDeleteData" icon="delete"> Xóa</a-button>
        <a-button type="dashed" style="background-color: #ddb72a; color: white" @click="handleOpenRecycleBin" icon="delete"> Thùng rác</a-button>
        <a-button type="primary" @click="() => visibleAssignTagModal = true" icon="tag"> Gắn tag</a-button>
        <a-button type="danger" @click="() => visibleUnassignTagModal = true" icon="tag"> Gỡ tag</a-button>

        <!-- Thêm các custom actions ở Component cha tại đây (template #actions) -->
        <slot name="actions" />
      </a-space>
    </div>
    <br>
    <div id="filters">
      <a-form-model layout="inline">
        <a-form-model-item label="ID">
          <a-select mode="tags" allowClear placeholder="ID" style="width: 150px;" v-model="filter.ids">
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="UID">
          <a-select ref="filter_uids" allowClear mode="tags" placeholder="UID" style="width: 150px;" v-model="filter.uids">
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="Thời gian tạo">
          <a-range-picker v-model="filter.registration_time" />
        </a-form-model-item>

        <a-form-model-item label="Tags">
          <a-select mode="multiple" :allowClear="true" placeholder="Tags" style="width: 200px;" v-model="filter.tags">
            <div slot="dropdownRender" slot-scope="menu">
              <v-nodes :vnodes="menu" />
              <a-divider style="margin: 0px 0;" />
              <div
                style="padding: 8px 8px; cursor: pointer;"
                @mousedown="e => e.preventDefault()"
                @click="() => visibleAddTagModal = true"
              >
                <a-icon type="plus" /> Thêm tag
              </div>
            </div>
            <a-select-option v-for="tag in tags" :key="tag.id" :value="tag.id">
              <a-tag closable @close="(e) => handleDeleteTag(e, tag)">{{tag.title}}</a-tag>
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="Loại trừ tags">
          <a-select mode="multiple" :allowClear="true" placeholder="Tags" style="width: 200px;" v-model="filter.excludeTags">
            <a-select-option v-for="tag in tags" :key="tag.id" :value="tag.id">
              <a-tag>{{tag.title}}</a-tag>
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="Note">
          <a-input placeholder="Note" style="width: 400px;" v-model="filter.note"></a-input>
        </a-form-model-item>

        <!-- Thêm các custom filters ở Component cha tại đây (template #filters) -->
        <slot name="filters" />

        <a-form-model-item>
          <a-button type="primary" @click="wrapFetchData" icon="filter"> Lọc</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <br>
    <a-table
      id="accounts-table"
      row-key="id"
      :columns="columns"
      :data-source="processedData"
      :loading="loading"
      :row-selection="rowSelection"
      :pagination="pagination"
      :scroll="{ x: 2000, y: 450 }"
    bordered>

      <!-- Custom cách hiển thị table ở Component cha tại đây (template #customRender) -->
      <template v-for="col in columns" :slot="col.scopedSlots?.customRender" slot-scope="text, record">
        <slot :name="col.scopedSlots?.customRender" v-bind="{ text, record }" />
      </template>
    </a-table>

    <!-- Modal import data -->
    <a-modal width="1000px" v-model="visibleImportDataModal" title="Import dữ liệu" okText="Import" @ok="handleImportData" :confirm-loading="loading">
      <a-card title="Các trường dữ liệu" class="card-xam">
        <a-tag v-for="field in details.fields" :key="field.key" @click="importDataAddField(field.key)">{{field.title}}</a-tag>
      </a-card>
      <br>
      <a-card title="Dữ liệu mẫu" class="card-xam">
        <div class="actions">
          <a-button type="primary" @click="() => importSelectedFields.pop()">Xóa cuối</a-button>
          <a-button type="danger" style="margin-left: 15px" @click="() => importSelectedFields = []">Xóa toàn bộ</a-button>
        </div>
        <a-form-model-item label="Dấu phân cách">
          <a-input style="width: 200px;" v-model="delimiter"></a-input>
        </a-form-model-item>
        <a-textarea disabled style="resize: none;" :value="displayImportSelectedFields"></a-textarea>
      </a-card>
      <br>
      <a-card title="Dữ liệu import" class="card-xam">
        <div>
          <a-checkbox v-model="importDuplicateCheck">Kiểm tra trùng lặp?</a-checkbox>
        </div>
        <br>
        <a-upload :multiple="true" :file-list="importFileList" :remove="handleRemoveImportFile" :before-upload="handleBeforeUploadImportFile" :disabled="this.importDataTextarea.length > 0">
          <a-button> <a-icon type="upload" /> Chọn file để import </a-button>
        </a-upload>
        <br>
        <a-select mode="multiple" :allowClear="true" placeholder="Tags" style="width: 200px;" v-model="importDataTags">
          <div slot="dropdownRender" slot-scope="menu">
            <v-nodes :vnodes="menu" />
            <a-divider style="margin: 0px 0;" />
            <div
              style="padding: 8px 8px; cursor: pointer;"
              @mousedown="e => e.preventDefault()"
              @click="() => visibleAddTagModal = true"
            >
              <a-icon type="plus" /> Thêm tag
            </div>
          </div>
          <a-select-option v-for="tag in tags" :key="tag.id" :value="tag.id">
            <a-tag>{{tag.title}}</a-tag>
          </a-select-option>
        </a-select>
        <br>
        <br>
        <a-textarea :auto-size="{ minRows: 10, maxRows: 20 }" :disabled="this.importFileList.length > 0" v-model="importDataTextarea"></a-textarea>
      </a-card>
    </a-modal>

    <!-- Modal export data -->
    <a-modal width="1000px" :ok-button-props="{ props: { disabled: exportAll } }" v-model="visibleExportDataModal" title="Export dữ liệu" okText="Export" @ok="handleExportData" :confirm-loading="loading">
      <a-card title="Các trường dữ liệu" class="card-xam">
        <a-tag v-for="field in details.fields" :key="field.key" @click="exportDataAddField(field.key)">{{field.title}}</a-tag>
      </a-card>
      <br>
      <a-card title="Dữ liệu mẫu" class="card-xam">
        <div class="actions">
          <a-button type="primary" @click="() => exportSelectedFields.pop()">Xóa cuối</a-button>
          <a-button type="danger" style="margin-left: 15px" @click="() => exportSelectedFields = []">Xóa toàn bộ</a-button>
        </div>
        <a-form-model-item label="Dấu phân cách">
          <a-input style="width: 200px;" v-model="delimiter"></a-input>
        </a-form-model-item>
        <a-textarea disabled style="resize: none;" :value="displayExportSelectedFields"></a-textarea>
      </a-card>
      <br>
      <a-card title="Dữ liệu export" class="card-xam">
        <a-checkbox v-model="exportAll">
          {{ (exportAll) ? 'Export tất cả' : 'Export trang hiện tại' }}
        </a-checkbox>
        <br>
        <div v-if="exportAll">
          <br>
          <span>Kích thước</span>
          <a-input
            :default-value="exportPageSize"
            @keydown.enter="e => updatePageSize(e.target.value)"
            style="width: 200px; margin-left: 15px"
            type="number"
            placeholder="Input size"
          />
          <br><br>
          <a-button 
            style="margin-right: 15px; margin-bottom: 15px" 
            v-for="link in exportLinks" 
            :key="link.page" 
            :loading="loadingPages.includes(link.page)" 
            :class="{ downloaded: downloadedPages.includes(link.page) }"
            type="button"
            @click="exportFromLink(link.page, link.pageSize)"
          >
            <template v-if="downloadedPages.includes(link.page)">
              <a-icon type="check-circle" /> Download {{link.pageSize * (link.page - 1)}}-{{(link.pageSize * (link.page - 1)) + link.pageSize}}
            </template>
            <template v-else>
              <a-icon type="cloud-download" /> Download {{link.pageSize * (link.page - 1)}}-{{(link.pageSize * (link.page - 1)) + link.pageSize}}
            </template>
          </a-button>
        </div>
        <br>
        <a-textarea 
          ref="exportTextarea" 
          :auto-size="{ minRows: 10, maxRows: 20 }" 
          @dblclick="handleSelectAllAndCopyExportData" 
          :readonly="true" 
          v-model="exportDataTextarea">
        </a-textarea>
      </a-card>
    </a-modal>

    <!-- modal thêm tags -->
    <a-modal v-model="visibleAddTagModal" title="Thêm tag" okText="Thêm" @ok="handleAddTag" :ok-button-props="{ props: { disabled: !newTagTitleToAdd } }">
      <a-input placeholder="Title" v-model="newTagTitleToAdd" />
    </a-modal>

    <!-- modal gắn tags -->
    <a-modal v-model="visibleAssignTagModal" title="Gắn tag" okText="OK" @ok="handleAssignTag" :ok-button-props="{ props: { disabled: tagIdForAssign.length === 0 } }">
      <div><p>Bạn đã chọn <b><i>{{selectedDataIds?.length || pagination.total}}</i></b> dữ liệu!</p></div>
      <a-select mode="multiple" style="width: 100%" :allowClear="true" placeholder="Tag" v-model="tagIdForAssign">
        <a-select-option v-for="tag in tags" :key="tag.id" :value="tag.id">
          <a-tag>{{tag.title}}</a-tag>
        </a-select-option>
      </a-select>
    </a-modal>

    <!-- modal gỡ tags -->
    <a-modal v-model="visibleUnassignTagModal" title="Gỡ tag" okText="OK" @ok="handleUnassignTagByFilter" :ok-button-props="{ props: { disabled: tagIdForUnassign.length === 0 } }">
      <div><p>Bạn đã chọn <b><i>{{selectedDataIds?.length || pagination.total}}</i></b> dữ liệu!</p></div>
      <a-select mode="multiple" style="width: 100%" :allowClear="true" placeholder="Tag" v-model="tagIdForUnassign">
        <a-select-option v-for="tag in tags" :key="tag.id" :value="tag.id">
          <a-tag>{{tag.title}}</a-tag>
        </a-select-option>
      </a-select>
    </a-modal>

    <!-- modal thùng rác -->
    <a-modal id="recycleBin-modal" width="400px" v-model="visibleRecycleBinModal" title="Thùng rác" @ok="() => visibleRecycleBinModal = false">
      <a-space>
        Trong thùng rác đang có <b><i>{{countBin}}</i></b> dữ liệu!
        <a-button type="link" shape="circle" icon="reload" @click="handleFetchBin"/>
      </a-space>
      <br><br>
      <a-space 
        v-if="countBin && (binProcessingStatus == 'pending')" 
        size="large" 
        style="width: 100%; display: flex; justify-content: center;"
      >
        <a-button type="primary" icon="sync" @click="handleRestoreTrash" :loading="loadings.recycleBin" style="background-color: #25c425;">
          Khôi phục
        </a-button>
        <a-button type="danger" icon="close" @click="handleRemoveTrash" :loading="loadings.recycleBin">
          Xóa bỏ
        </a-button>
      </a-space>
      <div v-if="binRunningProcess != null" style="color: #7596e9;">
        Tiến trình <b>{{binRunningProcess}}</b> đang chạy...
      </div>
    </a-modal>
  </div>
</template>

<style>
#accounts-table .ant-badge-status-dot {
  width: 10px !important;
  height: 10px !important;
}

#accounts-table .ant-badge-status-text {
  margin-left: 0px !important;
}

.card-xam .ant-card-head{
  background: #fafafa;
}

.card-xam .ant-tag{
  margin-bottom: 8px;
}

.downloaded {
  border: 1px solid #52c41a !important;
  color: #52c41a !important;
}
</style>

<script>
import fileDownload from 'js-file-download';
import { mapActions } from 'vuex';

function getSelectedTitles(fields, selecteds) {
  return selecteds.reduce((acc, key) => {
    const field = fields.find(field => field.key === key);
    if (field) {
      acc.push(field.title);
    }
    return acc;
  }, []);
}

export default {
  components: {
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    }
  },
  name: 'DataManagePage',
  props: {
    columns: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
      validator(value) {
        // Kiểm tra mỗi phần tử phải là object có `title` và `key` dạng string
        return Array.isArray(value) && value.every(field => {
          return (
            typeof field === 'object' &&
            typeof field.title === 'string' &&
            typeof field.key === 'string'
          );
        });
      }
    },
    storeNamespace: {
      type: String,
      required: true,
    },
    tagIndex: {
      type: String,
      required: true,
    },
    propsFilter: {
      type: Object,
      default: () => ({}),
    },
    page: {
      type: {
        total: Number,
        pageSize: Number,
        current: Number,
        showSizeChanger: Boolean,
        pageSizeOptions: Array,
      },
      required: true
    }
  },
  data() {
    return {
      app: this.$root.$children[0],
      loading: false,

      loadings: {
        recycleBin: false,
      },

      details: {
        fields: this.fields
      },

      // filters Object
      filter: {         
        page: 1,
        pageSize: 10,
        uids: [],
        ids: [],
        tfa: undefined,
        note: undefined,
      },

      selectedData: [],
      selectedDataIds: [],
      selectedDataUids: [],

      // table config
      pagination: {
        ... this.page,
        onChange: this.handleTableChange,
        onShowSizeChange: this.handlePageSizeChange,
        showQuickJumper: true,
        showTotal: (total, range) => {
          return `${range[0]} - ${range[1]} of ${total}`;
        }
      },

      // import/export data
      delimiter: '|',
      importSelectedFields: this.fields.slice(0, 5).map(field => field.key),
      importFileList: [],
      importDataTextarea: '',
      exportSelectedFields: this.fields.slice(0, 5).map(field => field.key),
      exportFileList: [],
      exportDataTextarea: '',
      exportAll: false,
      exportPageSize: 1000,
      importDuplicateCheck: true,
      importDataTags: [],
      // Lưu trạng thái tải khi export links
      downloadedPages: [],  // đã tải
      loadingPages: [],      // đang tải

      // Lưu tình trạng thùng rác
      countBin: 0,
      binProcessingStatus: 'pending',
      binRunningProcess: null,

      // tags
      tagIdForAssign: [],
      tagIdForUnassign: [],
      newTagTitleToAdd: undefined,

      // visible modal
      visibleRecycleBinModal: false,
      visibleImportDataModal: false,
      visibleExportDataModal: false,
      visibleAddTagModal: false,
      visibleAssignTagModal: false,
      visibleUnassignTagModal: false,
    };
  },

  mounted() {
    this.wrapFetchData();
    this.fetchTags({
      index: this.tagIndex
    });
    this.$refs.filter_uids.$el.addEventListener('paste', this.handlePasteUids);
  },

  beforeDestroy() {
    this.$refs.filter_uids.$el.removeEventListener('paste', this.handlePasteUids);
  },
  
  computed: {
    getPagination() {
      return this.$store.getters[`${this.storeNamespace}/getPagination`];
    },

    getData() {
      return this.$store.getters[`${this.storeNamespace}/getData`];
    },

    tags() {
      return this.$store.getters[`tag/getTags`];
    },

    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          // Update local state
          this.selectedDataIds = selectedRows.map(row => row.id);
          this.selectedDataUids = selectedRows.map(row => row.uid);
          this.selectedData = selectedRows;

          // Emit event to parent with selectedDataUids (and optionally other data)
          this.$emit('update:selection', {
            selectedDataUids: this.selectedDataUids,
            selectedDataIds: this.selectedDataIds,
            selectedData: this.selectedData,
          });
        },
      };
    },

    processedData() {
      return this.getData;
    },

    displayImportSelectedFields() {
      return getSelectedTitles(this.details.fields, this.importSelectedFields).join(` ${this.delimiter} `);
    },

    displayExportSelectedFields() {
      return getSelectedTitles(this.details.fields, this.exportSelectedFields).join(` ${this.delimiter} `);
    },

    importTextareaToData() {
      const text = this.importDataTextarea.trim();

      if (text.length == 0) {
        return [];
      }

      const lines = text.split('\n').map(line => line.trim());
      const data = lines.map(line => {
        const splitData = line.split(this.delimiter);
        const d = {};

        this.importSelectedFields.forEach((field, index) => {
          d[field] = splitData[index];
        });

        return d;
      });

      return data;
    },

    exportLinks() {
      const total = this.pagination.total;
      const pageSize = parseInt(this.exportPageSize);
      const totalPage = Math.ceil(total/pageSize);
      
      if(totalPage > 100) {
        return this.$notification.error({
          message: 'Kích thước không hợp lệ!',
          description: `Kích thước tối thiểu đối với trang hiện tại là ${Math.ceil(total/100)}`
        });
      }

      return Array(totalPage).fill(0).map((value, index) => {
        return {
          page: index + 1,
          pageSize: pageSize
        }
      })
    },
  },

  methods: {
    ...mapActions("tag", {
      fetchTags: "fetchTags",
      addTag: "addTag",
      assignTag: "assignTag",
      deleteTag: "deleteTag"
    }),

    fetchData(payload) {
      return this.$store.dispatch(`${this.storeNamespace}/fetchData`, payload);
    },

    importData(payload) {
      return this.$store.dispatch(`${this.storeNamespace}/importData`, payload);
    },

    exportData(payload) {
      return this.$store.dispatch(`${this.storeNamespace}/exportData`, payload);
    },

    deleteData(payload) {
      return this.$store.dispatch(`${this.storeNamespace}/deleteData`, payload);
    },

    unassignTag(payload) {
      return this.$store.dispatch(`${this.storeNamespace}/unassignTag`, payload);
    },

    unassignTagByFilter(payload) {
      return this.$store.dispatch(`${this.storeNamespace}/unassignTagByFilter`, payload);
    },

    countDeletedData() {
      return this.$store.dispatch(`${this.storeNamespace}/countDeletedData`);
    },

    removeTrash() {
      return this.$store.dispatch(`${this.storeNamespace}/removeTrash`);
    },

    restoreTrash() {
      return this.$store.dispatch(`${this.storeNamespace}/restoreTrash`);
    },

    buildFilter() {
      const filter = this.propsFilter ? { ...this.propsFilter } : {};

      if (this.filter.uids.length > 0) {
        filter.uids = this.filter.uids;
      }

      if (this.filter.ids.length > 0) {
        filter.ids = this.filter.ids;
      }

      if (typeof this.filter.tfa == 'number') {
        filter.tfa = this.filter.tfa;
      }

      if (this.filter.tags) {
        filter.tags = this.filter.tags;
      }

      if (this.filter.excludeTags) {
        filter.exclude_tags = this.filter.excludeTags;
      }

      if (this.filter.note) {
        filter.note = this.filter.note;
      }

      if (this.filter.registration_time && this.filter.registration_time?.length > 0) {
        filter.registration_time = {
          from: this.filter.registration_time[0].startOf('day').toISOString(),
          to: this.filter.registration_time[1].endOf('day').toISOString(),
        };
      }

      return filter;
    },

    async wrapFetchData() {
      this.loading = true;
      try {
        const filter = {...{
          page: this.filter.page,
          page_size: this.filter.pageSize
        }, ...this.buildFilter()};

        await this.fetchData(filter);

        this.loading = false;
        this.handlePagination();
      }
      catch(error) {
        this.loading = false;
        const serverError = error.response.data.error;
        this.$message.error(serverError.message);
      }
    },

    removeSelected() {
      this.selectedData = [];
      this.selectedDataIds = [];
      this.selectedDataUids = [];
    },

    handlePagination() {
      const pagination = this.getPagination;
      this.pagination.total = pagination.total;
      this.pagination.current = pagination.page;
      this.pagination.pageSize = pagination.page_size;

      this.$emit('update:pagination', {
        total: pagination.total,
        current: pagination.page,
        pageSize: pagination.page_size,
      });
    },

    handleTableChange(page, pageSize) {
      this.filter.page = page;
      this.filter.pageSize = pageSize;
      this.wrapFetchData();
    },

    handlePageSizeChange(page, pageSize) {
      this.filter.page = page;
      this.filter.pageSize = pageSize;
      this.wrapFetchData();
    },

    async handleAddTag() {
      try {
        const {message} = await this.addTag({
          index: this.tagIndex,
          title: this.newTagTitleToAdd.trim()
        });
        this.$message.success(message);
        this.visibleAddTagModal = false;
      }
      catch(error) {
        this.$message.error(error.response.data?.error?.message || error.response.data);
      }
    },

    async handleAssignTag() {
      const ids = [...this.selectedDataIds];

      try {
        const {message} = await this.assignTag({
          index: this.tagIndex,
          tag_ids: this.tagIdForAssign,
          filter: (ids && ids.length > 0) ? {ids} : this.buildFilter()
        });
        this.wrapFetchData();
        this.$message.success(message);
        this.visibleAssignTagModal = false;
      }
      catch(error) {
        this.$message.error(error.response.data?.error?.message || error.response.data);
      }
    },

    async handleUnassignTagByFilter() {
      const ids = [...this.selectedDataIds];

      try {
        const {message} = await this.unassignTagByFilter({
          filter: (ids && ids.length > 0) ? {ids} : this.buildFilter(),
          tag_ids: this.tagIdForUnassign,
        });
        this.wrapFetchData();
        this.$message.success(message);
        this.visibleUnassignTagModal = false;
      }
      catch(error) {
        this.$message.error(error.response.data?.error?.message || error.response.data);
      }
    },

    async handleDeleteTag(e, tag) {
      e.preventDefault();

      const {title, id} = tag;

      const handler = async () => {
        try {
          const {message} = await this.deleteTag({id});
          this.$message.success(message);
        }
        catch(error) {
          this.$message.error(error.response.data?.error?.message || error.response.data);
        }
      }
      
      this.$confirm({
        title: `Bạn có chắc muốn xóa tag "${title}"?`,
        onOk: handler
      });
    },

    tagExisted(tagId) {
      if (tagId && this.tags.length > 0) {
        const tag = this.tags.find(tag => tag.id == tagId);

        if (tag) {
          return tag;
        }
      }

      return false;
    },

    async handleImportData() {
      try {
        this.loading = true;
        if (this.importFileList.length > 0) {
          const files = this.importFileList;
          const {message} = await this.importData({
            attachments: files,
            template: this.importSelectedFields.join(this.delimiter),
            duplicateCheck: this.importDuplicateCheck,
            delimiter: this.delimiter,
            tags: this.importDataTags
          });
          this.$message.success(message);
        } else {
          const {message} = await this.importData({
            accounts: this.importTextareaToData,
            duplicateCheck: this.importDuplicateCheck,
            delimiter: this.delimiter,
            tags: this.importDataTags
          });
          this.$message.success(message);
        }
        this.loading = false;
        this.visibleImportDataModal = false;
        this.wrapFetchData();
      }
      catch(error) {
        this.loading = false;
        const serverError = error.response.data.error;
        this.$message.error(serverError.message);
      }
    },

    importDataAddField(fieldKey) {
      this.importSelectedFields.push(fieldKey);
    },
    
    handleRemoveImportFile(file) {
      const index = this.importFileList.findIndex(selectedFile => selectedFile.uid == file.uid);

      if (index > -1) {
        this.importFileList.splice(index, 1);
      }
    },

    exportDataAddField(fieldKey) {
      this.exportSelectedFields.push(fieldKey);
    },

    handleBeforeUploadImportFile(file) {
      if (this.importFileList.length >= 10) {
        this.$message.error('Import tối đa 10 files!');
        return false;
      }
      this.importFileList.push(file);
      return false;
    },

    handleExportData() {
      if (!this.exportAll) {
        const accounts = (this.selectedData.length > 0) ? this.selectedData : this.processedData;
        const lines = accounts.map(account => {
          const lineData = [];

          this.exportSelectedFields.forEach(field => {
            if (field.startsWith('headers.') && account.headers) {
              field = field.replace('headers.', '').replace(/-/g, '_');
              lineData.push(account.headers[field] || '-');
              return;
            }

            lineData.push(account[field] || '-');
          });

          return lineData.join(this.delimiter);
        });

        this.exportDataTextarea = lines.join('\n');
      }

      this.$message.success('Export dữ liệu thành công!');
    },

    handleSelectAllAndCopyExportData() {
      this.$refs.exportTextarea.$el.select();
      document.execCommand('copy');
      this.$message.success('Copied!');
    },

    async exportFromLink(page, pageSize) {
      // Thêm vào Set đang download
      this.loadingPages.push(page);

      const filters = this.buildFilter();

      filters.page = page;
      filters.page_size = pageSize;
      filters.delimiter = this.delimiter;
      filters.template = this.exportSelectedFields.join(this.delimiter);

      await this.app.callApi(async () => {
        const data = await this.exportData(filters);
        fileDownload(data, `x-accounts-${(page-1) * pageSize}-${page * pageSize}.txt`);

        // Thêm vào danh sách đã tải
        this.downloadedPages.push(page);
      });
      this.$message.success(`Export thành công file ${pageSize * (page - 1)}-${(pageSize * (page - 1)) + pageSize}!`);

      // Xóa khỏi Set đang download (để có thể tải lại)
      this.loadingPages = this.loadingPages.filter(e => e != page);
    },

    handleSoftDeleteData() {
      const ids = [...this.selectedDataIds];

      const handler = async () => {
        try {
          const {message} = await this.deleteData((ids && ids.length > 0) ? {ids} : this.buildFilter());
          this.$message.success(message);
          this.removeSelected();
          this.wrapFetchData();
        }
        catch(error) {
          this.$message.error(error.response.data.message);
        }
      }
      this.$confirm({
        title: (ids && ids.length > 0) ? 'Bạn có chắc muốn xóa những dữ liệu này?' : `Bạn có chắc muốn xóa ${this.pagination.total} dữ liệu theo bộ lọc hiện tại?`,
        content: 'Khi bạn click OK, dữ liệu sẽ bị xóa mềm, bạn không thật sự mất chúng, bạn chỉ không thể nhìn thấy, sử dụng chúng. Bạn có thể liên hệ ADMIN để khôi phục lại.',
        onOk: handler
      })
    },

    async handleFetchBin() {
      this.loadings.recycleBin = true;

      const { data } = await this.countDeletedData();
      this.countBin = data.count;
      this.binProcessingStatus = data.process_status;
      this.binRunningProcess = data.process;

      this.loadings.recycleBin = false;
    },

    async handleOpenRecycleBin() {
      this.visibleRecycleBinModal = true;
      await this.handleFetchBin();
    },

    handleRemoveTrash() {
      const handler = async () => {
        try {
          const { message } = await this.removeTrash();
          this.$message.success(message);
          await this.handleFetchBin();
        }
        catch(error) {
          this.$message.error(error.response.data.message);
        }
      }

      this.$confirm({
        title: `Bạn có chắc chắn muốn xóa ${this.countBin} dữ liệu trong thùng rác?`,
        content: `Khi bạn click OK, ${this.countBin} dữ liệu trong thùng rác sẽ bị xóa bỏ vĩnh viễn. Dữ liệu đã xóa không thể khôi phục.`,
        onOk: handler
      })
    },

    handleRestoreTrash() {
      const handler = async () => {
        try {
          const { message } = await this.restoreTrash();
          this.wrapFetchData();
          this.$message.success(message);
          await this.handleFetchBin();
        }
        catch(error) {
          this.$message.error(error.response.data.message);
        }
      }

      this.$confirm({
        title: `Bạn có chắc chắn muốn khôi phục ${this.countBin} dữ liệu trong thùng rác?`,
        content: `Khi bạn click OK, ${this.countBin} tài khoản trong thùng rác sẽ được khôi phục.`,
        onOk: handler
      })
    },

    handlePasteUids(event) {
      const uidsString = event.clipboardData.getData('text').trim();
      const uids = uidsString.split(/[\r\n]+/).map(line => line.trim());

      if (uids.length > 0) {
        const newUids = [...this.filter.uids, ...uids];

        this.filter.uids = Array.from(new Set(newUids));
      }
    },

    maskedEmail(email) {
      if (!email) return '';
      const [name, domain] = email.split('@');
      if (!name || !domain) return email;
      
      const maskedName = name[0] + '*'.repeat(Math.max(name.length - 1, 1));
      
      return `${maskedName}@${domain}`;
    },

    updatePageSize(value) {
      this.exportPageSize = parseInt(value);

      // Clear danh sách đã tải và đang tải
      this.loadingPages = [];
      this.downloadedPages = [];
    }
  },
};
</script>